

/* ============================================================
   Get Decked - Custom Deck Builder (demo)
   Live-preview EVA flooring configurator proof of concept.
   ============================================================ */

// ---- Get Decked's actual colour range (from getdeckedflooring.com.au/pages/colour-range) ----
const COLOURS = [
  {n:"Black",         c:"#17181a"},
  {n:"Light Grey",    c:"#c7c9c8"},
  {n:"Winter Grey",   c:"#9aa0a2"},
  {n:"Steel Grey",    c:"#686e71"},
  {n:"Teak",          c:"#a97f4f"},
  {n:"Red",           c:"#c2262e"},
  {n:"Ruby",          c:"#8d1f2d"},
  {n:"Orange",        c:"#ee7623"},
  {n:"Yellow",        c:"#f2c229"},
  {n:"Light Camel",   c:"#d5b98d"},
  {n:"Light Oak",     c:"#c1a274"},
  {n:"Navy",          c:"#1e3a5f"},
  {n:"Blue",          c:"#2761ad"},
  {n:"Light Blue",    c:"#7ab2d9"},
  {n:"Bashful Blue",  c:"#aac9e4"},
  {n:"Green",         c:"#2e7d3d"},
  {n:"Lime Green",    c:"#8dc63f"},
  {n:"Seafoam Green", c:"#a8d5c0"},
  {n:"Cream",         c:"#ece3cd"},
  {n:"Holly",         c:"#1e4d3b"},
  {n:"White",         c:"#f4f4f2"},
  {n:"Snow Camo",     c:"camoSnow",  base:"#d8dadb"},
  {n:"Steel Camo",    c:"camoSteel", base:"#7b8286"},
  {n:"Army Camo",     c:"camoArmy",  base:"#5b6142"},
];

const SHAPES = [
  {id:"rect",      n:"Rectangle"},
  {id:"rounded",   n:"Rounded"},
  {id:"casting",   n:"Casting deck"},
  {id:"triangle",  n:"Triangle"},
  {id:"trapezoid", n:"Trapezoid"},
  {id:"circle",    n:"Oval"},
];

// ---- model templates: hull silhouette + multi-piece mat kit per model ----
// paths live in a normalised template space, scaled to the model's real dimensions.
// DEMO layouts are approximations; the full build uses Get Decked's real cut files.
const MODELS = {
  boat: [
    { id:"qx490", name:"Quintrex 490 Renegade", sub:"Side console \u2022 4.99 m",
      defW:4990, defH:2240, space:[1000,440], coverage:0.48, textPos:[420,220], textSize:26, textWFrac:0.2,
      hull:"M15,220 C50,120 160,55 330,48 L935,48 Q978,48 978,92 L978,348 Q978,392 935,392 L330,392 C160,385 50,320 15,220 Z",
      context:["M492,112 L603,112 Q610,112 610,119 L610,198 Q610,205 603,205 L492,205 Q485,205 485,198 L485,119 Q485,112 492,112 Z"],
      pieces:[
        "M60,220 C95,155 175,110 290,100 L290,340 C175,330 95,285 60,220 Z",
        "M310,100 L620,100 Q635,100 635,115 L635,325 Q635,340 620,340 L310,340 Z M478,90 L622,90 L622,212 L478,212 Z",
        "M655,100 L855,100 Q870,100 870,115 L870,325 Q870,340 855,340 L655,340 Z",
        "M890,100 L935,100 Q955,100 955,125 L955,195 L890,195 Z",
        "M890,245 L955,245 L955,315 Q955,340 935,340 L890,340 Z",
      ]},
    { id:"qx540", name:"Quintrex 540 Top Ender", sub:"Side console \u2022 5.39 m",
      defW:5390, defH:2400, space:[1000,440], coverage:0.5, textPos:[455,220], textSize:30, textWFrac:0.22,
      hull:"M15,220 C50,118 165,52 340,46 L935,46 Q978,46 978,90 L978,350 Q978,394 935,394 L340,394 C165,388 50,322 15,220 Z",
      context:["M560,110 Q560,102 568,102 L672,102 Q680,102 680,110 L680,204 Q680,212 672,212 L568,212 Q560,212 560,204 Z"],
      pieces:[
        "M60,220 C95,152 180,106 300,96 L370,96 L370,344 L300,344 C180,334 95,288 60,220 Z",
        "M390,96 L700,96 Q715,96 715,111 L715,329 Q715,344 700,344 L390,344 Z M552,88 L688,88 L688,220 L552,220 Z",
        "M735,96 L930,96 Q955,96 955,121 L955,319 Q955,344 930,344 L735,344 Z",
      ]},
    { id:"st469", name:"Stacer 469 Outlaw", sub:"Tiller steer \u2022 4.69 m",
      defW:4690, defH:2130, space:[1000,430], coverage:0.52, textPos:[510,215], textSize:34, textWFrac:0.28,
      hull:"M18,215 C60,115 180,52 340,46 L930,46 Q975,46 975,90 L975,340 Q975,384 930,384 L340,384 C180,378 60,315 18,215 Z",
      pieces:[
        "M65,215 C100,150 180,105 300,96 L300,334 C180,325 100,280 65,215 Z",
        "M320,96 L700,96 Q715,96 715,111 L715,319 Q715,334 700,334 L320,334 Z",
        "M735,96 L925,96 Q950,96 950,121 L950,180 L735,180 Z",
        "M735,250 L950,250 L950,309 Q950,334 925,334 L735,334 Z",
      ]},
    { id:"pc480", name:"Polycraft 480 Brumby", sub:"Centre console \u2022 4.80 m",
      defW:4800, defH:2290, space:[1000,450], coverage:0.46, textPos:[428,225], textSize:26, textWFrac:0.17,
      hull:"M25,225 C70,130 185,62 340,55 L925,55 Q972,55 972,100 L972,350 Q972,395 925,395 L340,395 C185,388 70,320 25,225 Z",
      context:["M545,168 Q545,160 553,160 L687,160 Q695,160 695,168 L695,282 Q695,290 687,290 L553,290 Q545,290 545,282 Z"],
      pieces:[
        "M70,225 C105,165 185,120 300,112 L300,338 C185,330 105,285 70,225 Z",
        "M320,112 L900,112 Q930,112 930,142 L930,308 Q930,338 900,338 L320,338 Z M535,152 L705,152 L705,298 L535,298 Z",
      ]},
  ],
  pwc: [
    { id:"sdgtx", name:"Sea-Doo GTX / RXT", sub:"3.45 m",
      defW:3450, defH:1250, space:[1000,360], coverage:0.34, textPos:[866,180], textSize:15, textWFrac:0.115,
      hull:"M22,180 C55,95 165,52 320,52 L810,58 C925,68 972,108 972,180 C972,252 925,292 810,302 L320,308 C165,308 55,265 22,180 Z",
      context:["M345,118 L720,118 Q760,118 760,150 L760,210 Q760,242 720,242 L345,242 Q330,242 330,232 L330,128 Q330,118 345,118 Z"],
      pieces:[
        "M340,66 L755,72 Q772,74 772,90 L772,106 L340,106 Q326,106 326,90 L326,80 Q326,66 340,66 Z",
        "M340,294 L755,288 Q772,286 772,270 L772,254 L340,254 Q326,254 326,270 L326,280 Q326,294 340,294 Z",
        "M800,100 L920,100 Q945,110 945,150 L945,210 Q945,250 920,260 L800,260 Q788,260 788,248 L788,112 Q788,100 800,100 Z",
      ]},
    { id:"yamfx", name:"Yamaha FX WaveRunner", sub:"3.58 m",
      defW:3580, defH:1270, space:[1000,360], coverage:0.33, textPos:[868,180], textSize:13, textWFrac:0.1,
      hull:"M25,180 C48,108 135,60 300,55 L830,62 C935,72 968,112 968,180 C968,248 935,288 830,298 L300,305 C135,300 48,252 25,180 Z",
      context:["M330,120 L710,120 Q750,120 750,152 L750,208 Q750,240 710,240 L330,240 Q316,240 316,230 L316,130 Q316,120 330,120 Z"],
      pieces:[
        "M330,68 L760,74 Q778,76 778,92 L778,108 L330,108 Q316,108 316,92 L316,82 Q316,68 330,68 Z",
        "M330,292 L760,286 Q778,284 778,268 L778,252 L330,252 Q316,252 316,268 L316,278 Q316,292 330,292 Z",
        "M795,95 L920,95 Q945,103 945,138 L945,172 L795,172 Z",
        "M795,188 L945,188 L945,222 Q945,257 920,265 L795,265 Z",
      ]},
    { id:"sdspark", name:"Sea-Doo Spark", sub:"3.05 m",
      defW:3050, defH:1180, space:[1000,340], coverage:0.3, textPos:[845,170], textSize:12, textWFrac:0.1,
      hull:"M28,170 C60,100 160,58 320,55 L790,60 C905,70 955,105 955,170 C955,235 905,270 790,280 L320,285 C160,282 60,240 28,170 Z",
      context:["M355,115 L700,115 Q735,115 735,142 L735,198 Q735,225 700,225 L355,225 Q342,225 342,216 L342,124 Q342,115 355,115 Z"],
      pieces:[
        "M355,70 L730,76 Q746,78 746,92 L746,105 L355,105 Q342,105 342,92 L342,84 Q342,70 355,70 Z",
        "M355,270 L730,264 Q746,262 746,248 L746,235 L355,235 Q342,235 342,248 L342,256 Q342,270 355,270 Z",
        "M775,100 L890,100 Q928,112 928,150 L928,190 Q928,228 890,240 L775,240 Q763,240 763,228 L763,112 Q763,100 775,100 Z",
      ]},
  ],
};

const PATTERNS = [
  {id:"plain",    n:"Plain"},
  {id:"diamonds", n:"Diamonds"},
  {id:"topo",     n:"Topographic"},
  {id:"hourglass",n:"Hourglass"},
  {id:"alligator",n:"Alligator skin"},
  {id:"scales",   n:"Fish scales"},
  {id:"lines50",  n:"Lines 50mm"},
  {id:"lines90",  n:"Lines 90mm"},
  {id:"hex",      n:"Hexagon"},
  {id:"border",   n:"Thinline border"},
];


/* ---- U-DEK's real range -------------------------------------------------
   Customers may only pick a laminate U-DEK actually make. The old picker let
   any of 24 colours pair with any other: 576 options, of which 35 exist.
   Photos are U-DEK's own, hosted in this store's Files.
   ------------------------------------------------------------------------ */
const COMBOS = [
  {top:"Black", bot:"Winter Grey", name:"Black / Winter Grey", img:"https://getdeckedflooring.com.au/cdn/shop/files/black-winter-grey.jpg"},
  {top:"Light Grey", bot:"Winter Grey", name:"Light Grey / Winter Grey", img:"https://getdeckedflooring.com.au/cdn/shop/files/light-grey-winter-grey.jpg"},
  {top:"Light Grey", bot:"Black", name:"Light Grey / Black", img:"https://getdeckedflooring.com.au/cdn/shop/files/light-grey-black.jpg"},
  {top:"Teak", bot:"Black", name:"Teak / Black", img:"https://getdeckedflooring.com.au/cdn/shop/files/teak-black.jpg"},
  {top:"Steel Grey", bot:"Winter Grey", name:"Steel Grey / Winter Grey", img:"https://getdeckedflooring.com.au/cdn/shop/files/steel-grey-winter-grey.jpg"},
  {top:"Winter Grey", bot:"Black", name:"Winter Grey / Black", img:"https://getdeckedflooring.com.au/cdn/shop/files/winter-grey-black.jpg"},
  {top:"Winter Grey", bot:"Light Grey", name:"Winter Grey / Light Grey", img:"https://getdeckedflooring.com.au/cdn/shop/files/winter-grey-light-grey.jpg"},
  {top:"Steel Grey", bot:"Black", name:"Steel Grey / Black", img:"https://getdeckedflooring.com.au/cdn/shop/files/steel-grey-black.jpg"},
  {top:"Black", bot:"Teak", name:"Black / Teak", img:"https://getdeckedflooring.com.au/cdn/shop/files/black-teak.jpg"},
  {top:"Winter Grey", bot:"Steel Grey", name:"Winter Grey / Steel Grey", img:"https://getdeckedflooring.com.au/cdn/shop/files/winter-grey-steel-grey.jpg"},
  {top:"Light Oak", bot:"Black", name:"Light Oak / Black", img:"https://getdeckedflooring.com.au/cdn/shop/files/light-oak-black.jpg"},
  {top:"Teak", bot:"Navy", name:"Teak / Navy", img:"https://getdeckedflooring.com.au/cdn/shop/files/teak-navy.jpg"},
  {top:"Teak", bot:"Steel Grey", name:"Teak / Steel Grey", img:"https://getdeckedflooring.com.au/cdn/shop/files/teak-steel-grey.jpg"},
  {top:"Teak", bot:"Winter Grey", name:"Teak / Winter Grey", img:"https://getdeckedflooring.com.au/cdn/shop/files/teak-winter-grey.jpg"},
  {top:"Teak", bot:"Holly", name:"Teak / Holly", img:"https://getdeckedflooring.com.au/cdn/shop/files/teak-holly.jpg"},
  {top:"Light Camel", bot:"Light Oak", name:"Light Camel / Light Oak", img:"https://getdeckedflooring.com.au/cdn/shop/files/light-camel-light-oak.jpg"},
  {top:"Light Camel", bot:"Black", name:"Light Camel / Black", img:"https://getdeckedflooring.com.au/cdn/shop/files/light-camel-black.jpg"},
  {top:"Steel Grey", bot:"Light Camel", name:"Steel Grey / Light Camel", img:"https://getdeckedflooring.com.au/cdn/shop/files/steel-grey-light-camel.jpg"},
  {top:"Black", bot:"Light Camel", name:"Black / Light Camel", img:"https://getdeckedflooring.com.au/cdn/shop/files/black-light-camel.jpg"},
  {top:"Black", bot:"Black", name:"Black / Black", img:"https://getdeckedflooring.com.au/cdn/shop/files/black-black.jpg"},
  {top:"Winter Grey", bot:"Teak", name:"Winter Grey / Teak", img:"https://getdeckedflooring.com.au/cdn/shop/files/winter-grey-teak.jpg"},
  {top:"Black", bot:"Blue", name:"Black / Blue", img:"https://getdeckedflooring.com.au/cdn/shop/files/black-blue.jpg"},
  {top:"Winter Grey", bot:"Blue", name:"Winter Grey / Blue", img:"https://getdeckedflooring.com.au/cdn/shop/files/winter-grey-blue.jpg"},
  {top:"Steel Grey", bot:"Light Blue", name:"Steel Grey / Light Blue", img:"https://getdeckedflooring.com.au/cdn/shop/files/steel-grey-light-blue.jpg"},
  {top:"Winter Grey", bot:"Bashful Blue", name:"Winter Grey / Bashful Blue", img:"https://getdeckedflooring.com.au/cdn/shop/files/winter-grey-bashful-blue.jpg"},
  {top:"Steel Grey", bot:"Green", name:"Steel Grey / Green", img:"https://getdeckedflooring.com.au/cdn/shop/files/steel-grey-green.jpg"},
  {top:"Steel Grey", bot:"Seafoam Green", name:"Steel Grey / Seafoam", img:"https://getdeckedflooring.com.au/cdn/shop/files/steel-grey-seafoam.jpg"},
  {top:"Winter Grey", bot:"Seafoam Green", name:"Winter Grey / Seafoam", img:"https://getdeckedflooring.com.au/cdn/shop/files/winter-grey-seafoam.jpg"},
  {top:"Light Grey", bot:"Seafoam Green", name:"Light Grey / Seafoam", img:"https://getdeckedflooring.com.au/cdn/shop/files/light-grey-seafoam.jpg"},
  {top:"Light Grey", bot:"Bashful Blue", name:"Light Grey / Bashful Blue", img:"https://getdeckedflooring.com.au/cdn/shop/files/light-grey-bashful-blue.jpg"},
  {top:"Black", bot:"Orange", name:"Black / Orange", img:"https://getdeckedflooring.com.au/cdn/shop/files/black-orange.jpg"},
  {top:"Black", bot:"Red", name:"Black / Red", img:"https://getdeckedflooring.com.au/cdn/shop/files/black-red.jpg"},
  {top:"Light Grey", bot:"White", name:"Light Grey / White", img:"https://getdeckedflooring.com.au/cdn/shop/files/light-grey-white.jpg"},
  {top:"Army Camo", bot:"Army Camo", name:"Army Camo", single:true, img:"https://getdeckedflooring.com.au/cdn/shop/files/army-camo.jpg"},
  {top:"Snow Camo", bot:"Snow Camo", name:"Snow Camo", single:true, img:"https://getdeckedflooring.com.au/cdn/shop/files/snow-camo.jpg"}
];
const TRI = [
  {name:"Winter Grey / Blue / Black", cols:["Winter Grey","Blue","Black"], img:"https://getdeckedflooring.com.au/cdn/shop/files/winter-grey-blue-black.jpg"},
  {name:"Black / Blue / Winter Grey", cols:["Black","Blue","Winter Grey"], img:"https://getdeckedflooring.com.au/cdn/shop/files/black-blue-winter-grey.jpg"},
  {name:"Steel Grey / Orange / Black", cols:["Steel Grey","Orange","Black"], img:"https://getdeckedflooring.com.au/cdn/shop/files/steel-grey-orange-black.jpg"},
  {name:"Black / Orange / Steel Grey", cols:["Black","Orange","Steel Grey"], img:"https://getdeckedflooring.com.au/cdn/shop/files/black-orange-steel-grey.jpg"},
  {name:"Winter Grey / White / Black", cols:["Winter Grey","White","Black"], img:"https://getdeckedflooring.com.au/cdn/shop/files/winter-grey-white-black.jpg"},
  {name:"Light Grey / Winter Grey / Steel Grey", cols:["Light Grey","Winter Grey","Steel Grey"], img:"https://getdeckedflooring.com.au/cdn/shop/files/light-grey-winter-grey-steel-grey.jpg"}
];
const cn = n => COLOURS.find(c => c.n === n);
const isTri = () => S.mode === "tri";

// ---- state ----
const S = {
  category:"boat", model:MODELS.boat[0], shape:"rect",
  w:4990, h:2240, r:60,
  thickness:6, pattern:"diamonds",
  top:COLOURS[0], bot:COLOURS[3],
  activeTab:"top", bevel:true, text:"", patScale:1, patStretch:1,
  mode:"dual", combo:null,
};
const activeTemplate = () => S.category==="pad" ? null : S.model;
const shapeName = () => activeTemplate() ? S.model.name : SHAPES.find(s=>s.id===S.shape).n;

// ---- helpers ----
const $ = id => document.getElementById(id);
const fmt = n => n.toLocaleString("en-AU");

function colourFill(col, forPattern){
  if(col.c.startsWith("camo")) return forPattern ? col.base : `url(#${col.c})`;
  return col.c;
}

// ---- build shape selector ----
const shapeIcons = {
  rect:      '<rect x="4" y="9" width="34" height="24" rx="2" fill="none" stroke="#333" stroke-width="2"/>',
  rounded:   '<rect x="4" y="9" width="34" height="24" rx="9" fill="none" stroke="#333" stroke-width="2"/>',
  casting:   '<path d="M6 33 L6 14 Q6 9 12 9 L30 9 Q36 9 36 14 L36 33 L27 33 L27 24 L15 24 L15 33 Z" fill="none" stroke="#333" stroke-width="2"/>',
  triangle:  '<path d="M21 8 L38 33 L4 33 Z" fill="none" stroke="#333" stroke-width="2"/>',
  trapezoid: '<path d="M12 9 L30 9 L38 33 L4 33 Z" fill="none" stroke="#333" stroke-width="2"/>',
  circle:    '<ellipse cx="21" cy="21" rx="17" ry="12" fill="none" stroke="#333" stroke-width="2"/>',
};
SHAPES.forEach(s => {
  const b = document.createElement("button");
  b.className = "shape-btn" + (s.id===S.shape ? " active" : "");
  b.innerHTML = `<svg width="42" height="42" viewBox="0 0 42 42">${shapeIcons[s.id]}</svg><span>${s.n}</span>`;
  b.onclick = () => { S.shape = s.id;
    document.querySelectorAll(".shape-btn").forEach(x=>x.classList.remove("active"));
    b.classList.add("active");
    if(S.w > 3200){ S.w = 2400; S.h = 1200; syncDims(); }
    applyShapeUI();
    render(); };
  $("shapeGrid").appendChild(b);
});

function syncDims(){
  $("wRange").value = S.w; $("wNum").value = S.w;
  $("hRange").value = S.h; $("hNum").value = S.h;
}

function drawModelList(){
  $("modelList").innerHTML = "";
  (MODELS[S.category] || []).forEach(m => {
    const b = document.createElement("button");
    b.className = "model-btn" + (S.model && S.model.id===m.id ? " active" : "");
    b.innerHTML = `${m.name}<small>${m.sub}</small>`;
    b.onclick = () => { S.model = m; S.w = m.defW; S.h = m.defH; syncDims(); drawModelList(); render(); };
    $("modelList").appendChild(b);
  });
}

[...$("catSeg").children].forEach(b => b.onclick = () => {
  S.category = b.dataset.cat;
  [...$("catSeg").children].forEach(x=>x.classList.remove("active"));
  b.classList.add("active");
  const isPad = S.category==="pad";
  $("modelList").style.display = isPad ? "none" : "flex";
  $("shapeGrid").style.display = isPad ? "grid" : "none";
  $("catHint").textContent = isPad
    ? "Full version: upload a photo or template of your deck, hatch, or tray and we quote the exact shape."
    : "Demo templates are approximations \u2014 the full version uses Get Decked's real cut files for each model, and customers can request any boat not listed.";
  if(isPad){ S.w = 2400; S.h = 1200; }
  else { S.model = MODELS[S.category][0]; S.w = S.model.defW; S.h = S.model.defH; drawModelList(); }
  syncDims();
  applyShapeUI();
  render();
});

function applyShapeUI(){
  const tpl = activeTemplate();
  $("cornerRow").style.display = (!tpl && (S.shape==="rect"||S.shape==="rounded"||S.shape==="casting")) ? "flex" : "none";
  $("wLabel").textContent = tpl ? "Length" : "Width";
  $("hLabel").textContent = tpl ? "Beam" : "Height";
}
drawModelList();

// ---- pattern selector ----
PATTERNS.forEach(p => {
  const b = document.createElement("button");
  b.textContent = p.n;
  if(p.soon){ b.className="soon"; b.title="Available in the full version"; }
  if(p.id===S.pattern) b.classList.add("active");
  b.onclick = () => { if(p.soon) return;
    S.pattern = p.id;
    [...$("patternSeg").children].forEach(x=>x.classList.remove("active"));
    b.classList.add("active"); render(); };
  $("patternSeg").appendChild(b);
});

// ---- thickness ----
[...$("thicknessSeg").children].forEach(b => b.onclick = () => {
  S.thickness = +b.dataset.th;
  [...$("thicknessSeg").children].forEach(x=>x.classList.remove("active"));
  b.classList.add("active"); render();
});

// ---- colour combinations (real U-DEK laminates) ----
function drawCombos(){
  const grid = $("swatchGrid");
  if(!grid) return;
  const list = isTri() ? TRI : COMBOS;
  grid.innerHTML = "";
  list.forEach(item => {
    const cols = isTri() ? item.cols.map(cn) : [cn(item.top), cn(item.bot)];
    const sel  = S.combo && S.combo.name === item.name;
    const d = document.createElement("div");
    d.className = "sw combo" + (sel ? " active" : "");
    // colour bands sit underneath as a fallback: if a photo ever 404s the tile
    // still shows the right colours instead of an empty box
    const bands = cols.map((c,i) =>
      `<i style="flex:${isTri()?1:(i?1:2)};background:${(c&&(c.base||c.c))||"#ccc"};"></i>`).join("");
    d.innerHTML = `<div class="box combo-box">${bands}`
      + `<img src="${item.img}" alt="${item.name} U-DEK foam" loading="lazy" onerror="this.remove()">`
      + `</div><span>${item.name}</span>`;
    d.onclick = () => pickCombo(item);
    grid.appendChild(d);
  });
}
function pickCombo(item){
  S.combo = item;
  if(isTri()){
    S.top = cn(item.cols[0]); S.bot = cn(item.cols[1]);
    S.thickness = 9;                      // tri-colour is a 9 mm product only
    document.querySelectorAll("[data-th]").forEach(b =>
      b.classList.toggle("active", b.dataset.th === "9"));
  } else {
    S.top = cn(item.top); S.bot = cn(item.bot);
  }
  drawCombos(); render();
}
function setMode(m){
  S.mode = m;
  const dual = m === "dual";
  const tt = $("tabTop"), tb = $("tabBot");
  if(tt) tt.classList.toggle("active", dual);
  if(tb) tb.classList.toggle("active", !dual);
  const note = $("triNote"); if(note) note.style.display = dual ? "none" : "block";
  S.combo = null;
  pickCombo((dual ? COMBOS : TRI)[0]);
}
drawCombos();
pickCombo(COMBOS[0]);

if($("tabTop")) $("tabTop").onclick = () => setMode("dual");
if($("tabBot")) $("tabBot").onclick = () => setMode("tri");

// ---- dimension inputs ----
function bindPair(rangeId, numId, key){
  const r = $(rangeId), n = $(numId);
  r.oninput = () => { S[key] = +r.value; n.value = r.value; render(); };
  n.oninput = () => { S[key] = +n.value || S[key]; r.value = S[key]; render(); };
}
bindPair("wRange","wNum","w"); bindPair("hRange","hNum","h"); bindPair("rRange","rNum","r");
syncDims(); applyShapeUI();


// ---- pattern size & stretch ----
$("patScale").oninput = e => { S.patScale = e.target.value/100; $("patScaleVal").textContent = e.target.value + "%"; render(); };
$("patStretch").oninput = e => { S.patStretch = e.target.value/100; $("patStretchVal").textContent = e.target.value + "%"; render(); };
$("bevelToggle").onchange = e => { S.bevel = e.target.checked; render(); };
$("logoText").oninput = e => { S.text = e.target.value.toUpperCase(); render(); };

// ---- shape path ----
function shapePath(x, y, w, h, r){
  switch(S.shape){
    case "rect": case "rounded": {
      const rad = Math.min(S.shape==="rounded" ? Math.max(r, 30) : r, w/2, h/2);
      return `M${x+rad},${y} h${w-2*rad} a${rad},${rad} 0 0 1 ${rad},${rad} v${h-2*rad} a${rad},${rad} 0 0 1 -${rad},${rad} h-${w-2*rad} a${rad},${rad} 0 0 1 -${rad},-${rad} v-${h-2*rad} a${rad},${rad} 0 0 1 ${rad},-${rad} Z`;
    }
    case "casting": {
      const rad = Math.min(Math.max(r,20), w/3, h/3);
      const notchW = w*0.34, notchH = h*0.38;
      const nx1 = x + (w-notchW)/2, nx2 = nx1 + notchW;
      return `M${x+rad},${y} L${x+w-rad},${y} Q${x+w},${y} ${x+w},${y+rad} L${x+w},${y+h} L${nx2},${y+h} L${nx2},${y+h-notchH} Q${nx2},${y+h-notchH-14} ${nx2-14},${y+h-notchH-14} L${nx1+14},${y+h-notchH-14} Q${nx1},${y+h-notchH-14} ${nx1},${y+h-notchH} L${nx1},${y+h} L${x},${y+h} L${x},${y+rad} Q${x},${y} ${x+rad},${y} Z`;
    }
    case "triangle":  return `M${x+w/2},${y} L${x+w},${y+h} L${x},${y+h} Z`;
    case "trapezoid": return `M${x+w*0.22},${y} L${x+w*0.78},${y} L${x+w},${y+h} L${x},${y+h} Z`;
    case "circle":    return `M${x},${y+h/2} a${w/2},${h/2} 0 1 0 ${w},0 a${w/2},${h/2} 0 1 0 -${w},0 Z`;
  }
}

// ---- area (m2) ----
function areaM2(){
  const w = S.w/1000, h = S.h/1000;
  const tpl = activeTemplate();
  if(tpl) return w*h*tpl.coverage;
  switch(S.shape){
    case "triangle":  return w*h/2;
    case "trapezoid": return w*h*0.78;
    case "circle":    return Math.PI*(w/2)*(h/2);
    case "casting":   return w*h*0.87;
    default:          return w*h;
  }
}

// ---- pattern defs ----
function patternDefs(botFill){
  const g = colourFill(S.bot, true);
  const ps = S.patScale || 1, st = S.patStretch || 1;
  // keep the stretch axis consistent on screen: craft previews are drawn rotated 90deg
  const vert = !!activeTemplate();
  const gx = (vert ? ps : ps*st).toFixed(3), gy = (vert ? ps*st : ps).toFixed(3);
  const pt = `scale(${gx},${gy})`;
  const ptDir = vert ? pt + " rotate(-90)" : pt; // directional patterns stay upright on bow-up craft
  const blob = "M-30,0 C-30,-18 -14,-30 4,-28 C22,-26 32,-14 30,2 C28,18 12,28 -6,27 C-22,26 -30,14 -30,0 Z";
  return `
  <pattern id="pat-topo" width="220" height="220" patternUnits="userSpaceOnUse" patternTransform="${pt}">
    <g fill="none" stroke="${g}" stroke-width="2.4">
      <g transform="translate(60,70) rotate(12)">
        <path d="${blob}" transform="scale(2.0)"/>
        <path d="${blob}" transform="translate(6,4) scale(1.5) rotate(18)"/>
        <path d="${blob}" transform="translate(11,8) scale(1.05) rotate(38)"/>
        <path d="${blob}" transform="translate(15,12) scale(0.65) rotate(60)"/>
        <path d="${blob}" transform="translate(18,15) scale(0.32) rotate(85)"/>
      </g>
      <g transform="translate(168,172) rotate(-30)">
        <path d="${blob}" transform="scale(1.55)"/>
        <path d="${blob}" transform="translate(-7,5) scale(1.1) rotate(24)"/>
        <path d="${blob}" transform="translate(-12,9) scale(0.68) rotate(48)"/>
        <path d="${blob}" transform="translate(-15,12) scale(0.34) rotate(72)"/>
      </g>
      <path d="M-14,150 C26,118 60,154 96,134"/>
      <path d="M-14,166 C28,136 62,170 98,152"/>
      <path d="M136,26 C168,4 202,34 236,18"/>
      <path d="M124,42 C162,20 204,50 238,34"/>
    </g>
  </pattern>
  <pattern id="pat-hourglass" width="44" height="44" patternUnits="userSpaceOnUse" patternTransform="${ptDir}">
    <g fill="none" stroke="${g}" stroke-width="2.6" stroke-linejoin="round">
      <path d="M2,2 L42,2 L22,22 Z"/>
      <path d="M2,42 L42,42 L22,22 Z"/>
    </g>
  </pattern>
  <pattern id="pat-alligator" width="96" height="56" patternUnits="userSpaceOnUse" patternTransform="${pt}">
    <g fill="none" stroke="${g}" stroke-width="2.4">
      <rect x="4" y="4" width="38" height="20" rx="7"/>
      <rect x="52" y="4" width="38" height="20" rx="7"/>
      <rect x="-20" y="32" width="38" height="20" rx="7"/>
      <rect x="28" y="32" width="38" height="20" rx="7"/>
      <rect x="76" y="32" width="38" height="20" rx="7"/>
    </g>
  </pattern>
  <pattern id="pat-scales" width="44" height="36" patternUnits="userSpaceOnUse" patternTransform="${ptDir}">
    <g fill="none" stroke="${g}" stroke-width="2.6">
      <path d="M0,18 a22,18 0 0 1 44,0"/>
      <path d="M-22,36 a22,18 0 0 1 44,0"/>
      <path d="M22,36 a22,18 0 0 1 44,0"/>
    </g>
  </pattern>` + patternDefsLegacy();
}

function patternDefsLegacy(){
  const g = colourFill(S.bot, true);
  const ps = S.patScale || 1, st = S.patStretch || 1;
  // keep the stretch axis consistent on screen: craft previews are drawn rotated 90deg
  const vert = !!activeTemplate();
  const gx = (vert ? ps : ps*st).toFixed(3), gy = (vert ? ps*st : ps).toFixed(3);
  const pt = `scale(${gx},${gy})`;
  const ptDir = vert ? pt + " rotate(-90)" : pt; // directional patterns stay upright on bow-up craft
  return `
  <pattern id="pat-diamonds" width="46" height="46" patternUnits="userSpaceOnUse" patternTransform="${pt} rotate(45)">
    <rect width="46" height="46" fill="none"/>
    <line x1="0" y1="0" x2="0" y2="46" stroke="${g}" stroke-width="3.4"/>
    <line x1="0" y1="0" x2="46" y2="0" stroke="${g}" stroke-width="3.4"/>
  </pattern>
  <pattern id="pat-lines50" width="26" height="26" patternUnits="userSpaceOnUse" patternTransform="${pt}">
    <line x1="0" y1="13" x2="26" y2="13" stroke="${g}" stroke-width="3.2"/>
  </pattern>
  <pattern id="pat-lines90" width="46" height="46" patternUnits="userSpaceOnUse" patternTransform="${pt}">
    <line x1="0" y1="23" x2="46" y2="23" stroke="${g}" stroke-width="3.6"/>
  </pattern>
  <pattern id="pat-hex" width="56" height="97" patternUnits="userSpaceOnUse" patternTransform="${pt} scale(.62)">
    <path d="M28 0 L56 16 L56 48 L28 64 L0 48 L0 16 Z M28 64 L28 97 M28 0 L28 -33" fill="none" stroke="${g}" stroke-width="4.6"/>
    <path d="M0 81 L28 97 L56 81" fill="none" stroke="${g}" stroke-width="4.6"/>
  </pattern>
  <pattern id="camoSnow" width="90" height="90" patternUnits="userSpaceOnUse">
    <rect width="90" height="90" fill="#d8dadb"/>
    <path d="M8 12 q14 -10 26 2 t22 4 q10 8 -4 16 t-24 2 q-18 4 -20 -10 z" fill="#aeb4b7"/>
    <path d="M55 55 q16 -8 26 4 t8 18 q-8 12 -22 6 t-16 -12 q-6 -10 4 -16 z" fill="#8f9598"/>
    <path d="M10 60 q10 -12 22 -2 t6 18 q-10 10 -22 4 t-6 -20 z" fill="#c3c7c9"/>
    <path d="M60 6 q12 -6 22 4 t-2 16 q-12 6 -22 -2 t2 -18 z" fill="#9ba1a4"/>
  </pattern>
  <pattern id="camoSteel" width="90" height="90" patternUnits="userSpaceOnUse">
    <rect width="90" height="90" fill="#7b8286"/>
    <path d="M8 12 q14 -10 26 2 t22 4 q10 8 -4 16 t-24 2 q-18 4 -20 -10 z" fill="#565c60"/>
    <path d="M55 55 q16 -8 26 4 t8 18 q-8 12 -22 6 t-16 -12 q-6 -10 4 -16 z" fill="#3e4448"/>
    <path d="M10 60 q10 -12 22 -2 t6 18 q-10 10 -22 4 t-6 -20 z" fill="#9aa1a5"/>
    <path d="M60 6 q12 -6 22 4 t-2 16 q-12 6 -22 -2 t2 -18 z" fill="#666d71"/>
  </pattern>
  <pattern id="camoArmy" width="90" height="90" patternUnits="userSpaceOnUse">
    <rect width="90" height="90" fill="#5b6142"/>
    <path d="M8 12 q14 -10 26 2 t22 4 q10 8 -4 16 t-24 2 q-18 4 -20 -10 z" fill="#3c4128"/>
    <path d="M55 55 q16 -8 26 4 t8 18 q-8 12 -22 6 t-16 -12 q-6 -10 4 -16 z" fill="#2b2f1c"/>
    <path d="M10 60 q10 -12 22 -2 t6 18 q-10 10 -22 4 t-6 -20 z" fill="#757a52"/>
    <path d="M60 6 q12 -6 22 4 t-2 16 q-12 6 -22 -2 t2 -18 z" fill="#4a4f33"/>
  </pattern>`;
}

// ---- main render ----
function render(){
  const tplMode = !!activeTemplate();
  // templates draw the craft bow-LEFT (landscape): screen width = length, screen height = beam
  const VB_W = 900, VB_H = tplMode ? 470 : 640, PAD = tplMode ? 50 : 90;
  $("svg").setAttribute("viewBox", `0 0 ${VB_W} ${VB_H}`);
  const sw = S.w, sh = S.h;
  const scale = Math.min((VB_W-2*PAD)/sw, (VB_H-2*PAD)/sh);
  const w = sw*scale, h = sh*scale, r = S.r*scale;
  const x = (VB_W-w)/2, y = (VB_H-h)/2;

  const topFill = colourFill(S.top);
  const botLine = colourFill(S.bot, true);
  const tpl = activeTemplate();

  let body = "", clips = "", label = "";

  if(tpl){
    // ---- watercraft template: hull silhouette + multi-piece mat kit ----
    const [TW, TH] = tpl.space;
    const sx = w/TW, sy = h/TH, avg = (sx+sy)/2;
    const pid = "pat-"+S.pattern;
    let inner = `<path d="${tpl.hull}" fill="#e9eaeb" stroke="#b6babd" stroke-width="${2.4/avg}"/>`;
    (tpl.context||[]).forEach(c => inner += `<path d="${c}" fill="#d6d8d9" stroke="#b6babd" stroke-width="${1.8/avg}"/>`);
    tpl.pieces.forEach((p,i)=>{
      clips += `<clipPath id="pc${i}"><path d="${p}" clip-rule="evenodd"/></clipPath>`;
      inner += `<path d="${p}" fill="${topFill}" fill-rule="evenodd" stroke="rgba(0,0,0,.35)" stroke-width="${1.6/avg}"/>`;
      if(S.pattern!=="plain" && S.pattern!=="border")
        inner += `<path d="${p}" fill="url(#${pid})" fill-rule="evenodd" clip-path="url(#pc${i})"/>`;
      if(S.pattern==="border")
        inner += `<path d="${p}" fill="none" stroke="${botLine}" stroke-width="${8/avg}" clip-path="url(#pc${i})"/>`;
      if(S.bevel)
        inner += `<path d="${p}" fill="none" stroke="${botLine}" stroke-width="${7/avg}" clip-path="url(#pc${i})"/>`;
    });
    body = `<g transform="translate(${x},${y}) scale(${sx},${sy})">${inner}</g>`;
    if(S.text){
      const tx = x + tpl.textPos[0]*sx, ty = y + tpl.textPos[1]*sy;
      const fs = Math.min(tpl.textSize, (w*Math.min(0.6,(tpl.textWFrac||0.25)*2.2)) / (S.text.length*0.62));
      label = `<text x="${tx}" y="${ty+fs*0.35}" text-anchor="middle" font-family="Arial Black, Arial" font-weight="900" font-style="italic" font-size="${fs}" fill="${botLine}" letter-spacing="2">${S.text.replace(/[<>&]/g,"")}</text>`;
    }
  } else {
    // ---- generic pad shapes ----
    const path = shapePath(x, y, w, h, r);
    clips = `<clipPath id="clip"><path d="${path}"/></clipPath>`;
    let patternOverlay = "";
    if(S.pattern!=="plain" && S.pattern!=="border"){
      patternOverlay = `<path d="${path}" fill="url(#pat-${S.pattern})" clip-path="url(#clip)"/>`;
    }
    if(S.pattern==="border"){
      const inset = 18;
      const bp = shapePath(x+inset, y+inset, w-2*inset, h-2*inset, Math.max(0,r-inset*0.6));
      patternOverlay = `<path d="${bp}" fill="none" stroke="${botLine}" stroke-width="3.6"/>`;
    }
    const bevel = S.bevel ? `<path d="${path}" fill="none" stroke="${botLine}" stroke-width="7" clip-path="url(#clip)"/>` : "";
    body = `<path d="${path}" fill="${topFill}" filter="url(#shadow)"/>${patternOverlay}${bevel}`;
    if(S.text) label = `<text x="${VB_W/2}" y="${y+h/2+8}" text-anchor="middle" font-family="Arial Black, Arial" font-weight="900" font-style="italic" font-size="${Math.min(38, w/ (S.text.length*0.72))}" fill="${botLine}" letter-spacing="2">${S.text.replace(/[<>&]/g,"")}</text>`;
  }

  // dimension guides
  const dimColor = "#8a8f94";
  const dims = `
    <g stroke="${dimColor}" stroke-width="1" fill="${dimColor}" font-size="13" font-family="inherit">
      <line x1="${x}" y1="${y-26}" x2="${x+w}" y2="${y-26}"/>
      <line x1="${x}" y1="${y-32}" x2="${x}" y2="${y-20}"/>
      <line x1="${x+w}" y1="${y-32}" x2="${x+w}" y2="${y-20}"/>
      <text x="${x+w/2}" y="${y-34}" text-anchor="middle" stroke="none">${fmt(S.w)} mm</text>
      <line x1="${x-26}" y1="${y}" x2="${x-26}" y2="${y+h}"/>
      <line x1="${x-32}" y1="${y}" x2="${x-20}" y2="${y}"/>
      <line x1="${x-32}" y1="${y+h}" x2="${x-20}" y2="${y+h}"/>
      <text x="${x-36}" y="${y+h/2}" text-anchor="middle" transform="rotate(-90 ${x-36} ${y+h/2})" stroke="none">${fmt(S.h)} mm</text>
    </g>`;

  $("svg").innerHTML = `
    <defs>
      ${patternDefs()}
      ${clips}
      <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="0" dy="5" stdDeviation="7" flood-opacity="0.28"/>
      </filter>
    </defs>
    ${dims}
    ${body}
    ${label}
  `;

  // ---- summary ----
  const a = areaM2();
  const patName = PATTERNS.find(p=>p.id===S.pattern).n;

  $("dimLabel").textContent = `${fmt(S.w)} \u00d7 ${fmt(S.h)} mm`;
  $("chipTop").textContent = S.top.n; $("chipBot").textContent = S.bot.n;
  $("chipTopDot").style.background = S.top.base || S.top.c;
  $("chipBotDot").style.background = S.bot.base || S.bot.c;
  $("chipPat").textContent = patName;
  $("comboLabel").textContent = S.combo ? S.combo.name : `${S.top.n} / ${S.bot.n}`;
  $("sumDims").textContent = `${fmt(S.w)} \u00d7 ${fmt(S.h)} mm`;
  $("sumArea").textContent = a.toFixed(2)+" m\u00b2";
  $("sumMat").textContent = `${S.thickness} mm EVA${isTri()?" tri-colour":""}, ${patName.toLowerCase()}`;
  $("sumCol").textContent = S.combo ? S.combo.name : `${S.top.n} / ${S.bot.n}`;
}

// ---- quote modal ----
$("quoteBtn").onclick = () => {
  const a = areaM2();
  const patName = PATTERNS.find(p=>p.id===S.pattern).n;
  $("modalSummary").innerHTML = `
    <div><span>${activeTemplate() ? "Model" : "Shape"}</span><span>${shapeName()}</span></div>
    <div><span>Size</span><span>${fmt(S.w)} \u00d7 ${fmt(S.h)} mm (${a.toFixed(2)} m\u00b2)</span></div>
    <div><span>Material</span><span>${S.thickness} mm EVA</span></div>
    <div><span>Pattern</span><span>${patName}${S.patScale!==1 ? ` @ ${Math.round(S.patScale*100)}%` : ""}${S.patStretch!==1 ? " stretched" : ""}${S.bevel ? " + bevelled edge" : ""}</span></div>
    <div><span>Colours</span><span>${S.combo ? S.combo.name : S.top.n+" / "+S.bot.n}${isTri() ? " (TRI-COLOUR - quote only)" : ""}</span></div>
    ${S.text ? `<div><span>Routed text</span><span>"${S.text}"</span></div>` : ""}`;
  $("quoteForm").style.display = "block";
  $("sentMsg").style.display = "none";
  $("modalBg").classList.add("open");
};
$("modalClose").onclick = () => $("modalBg").classList.remove("open");
$("modalBg").onclick = e => { if(e.target===$("modalBg")) $("modalBg").classList.remove("open"); };
function bfDesignText(){
  const el = $("modalSummary");
  if(!el) return "";
  return [...el.querySelectorAll("div")]
    .map(r => [...r.querySelectorAll("span")].map(s => s.textContent.trim()).join(": "))
    .filter(Boolean).join(" | ");
}
(function(){
  const qf = $("quoteFormEl");
  if(!qf) return;

  /* Shopify protects storefront forms with a captcha whose token is injected by
     Shopify's own handler on the NATIVE submit event. The previous version called
     preventDefault() and posted with fetch(), which skipped that injection - so
     every real enquiry came back "Missing CAPTCHA token" and never reached Jason.
     Let the browser submit normally; just fill the design in first. */
  qf.addEventListener("submit", function(){
    const d = $("qDesign");
    if(d) d.value = bfDesignText();
    const b = $("sendBtn");
    // disable only after the submit is under way, or the browser cancels it
    if(b) setTimeout(function(){ b.disabled = true; b.textContent = "SENDING\u2026"; }, 0);
  }, true);

  /* Shopify bounces back to this page with ?contact_posted=true on success. */
  if(location.search.indexOf("contact_posted=true") > -1){
    const form = $("quoteForm"), sent = $("sentMsg"), bg = $("modalBg");
    if(form) form.style.display = "none";
    if(sent) sent.style.display = "block";
    if(bg) bg.classList.add("open");
  }
})();

render();

